<template>
  <v-container fluid>
    <v-row
      v-for="(ferramentas, categoria) in ferramentasAgrupadas"
      :id="`categoria-${categoria}`"
      :key="categoria"
      class="mx-auto"
    >
      <template v-if="ferramentas.length && (!categoriaIsPrivada(categoria) || userIsAdmin)">
        <h2 class="my-4 w-100">
          <span v-if="!categoriaIsPrivada(categoria)">
            {{ categoria }}
          </span>
          <v-tooltip v-else right>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" class="cat-privada-text" v-on="on">
                {{ categoria }}
              </span>
            </template>
            <span>Essa categoria foi marcada como privada, ou seja, só é exibida para administradores</span>
          </v-tooltip>
        </h2>
        <v-row>
          <v-col v-for="ferramenta in ferramentas" :key="ferramenta.id" xs="12" sm="6" md="4" lg="3">
            <v-hover v-slot:default="{ hover }">
              <a style="text-decoration: none">
                <v-card
                  :id="ferramenta.id"
                  :class="!ferramenta.status ? 'disabled-card' : ''"
                  :style="hover && !ferramenta.status ? 'cursor: not-allowed' : ''"
                  class="d-flex mx-auto my-auto px-2"
                  width="352px"
                  height="100%"
                  :color="hover && ferramenta.status ? 'grey lighten-2' : 'grey lighten-3'"
                  elevation="1"
                  :to="ferramenta.status ? ferramenta.link_rota_principal_completo : ''"
                  @click="!ferramenta.status && $event.preventDefault()"
                >
                  <hint v-if="!ferramenta.status" msg-modal="" :add-hexa-final-string="true">
                    <template slot="text">
                      Esta ferramenta não está habilitada para seu usuário, caso tenha interesse, entre em contato com um
                      especialista
                      <b>NORVEN</b>
                      pelo chat.
                    </template>
                  </hint>
                  <v-row no-gutters align="center" justify="center">
                    <v-col cols="2">
                      <v-icon class="d-flex justify-center my-auto" :size="40" color="#E5502C">{{ ferramenta.icone }}</v-icon>
                    </v-col>
                    <v-col cols="10">
                      <v-card-text class="mx-auto my-auto">
                        <div class="subtitle-2" style="word-break: normal">
                          {{ ferramenta.nome }}
                        </div>
                        <div class="caption text--secondary">
                          {{ ferramenta.descricao }}
                        </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </a>
            </v-hover>
          </v-col>
        </v-row>
      </template>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      Hint: () => import('@/components/general/Hint')
    },

    computed: {
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      },

      categoriasFiltered() {
        return this.categorias.filter((categoria) => {
          let todosItensAdminTrue = categoria.items.every((item) => item.admin);
          return !todosItensAdminTrue ? true : todosItensAdminTrue && this.userIsAdmin;
        });
      },

      categorias() {
        return this.$store.state.app.modulosPerfisLiberados.categorias;
      },

      ferramentasLiberadas() {
        return this.$store.state.app.modulosPerfisLiberados.ferramentas_liberadas;
      },
      ferramentasAgrupadas() {
        /* Sintaxe json implemntada para duplicar o valor de ferramentasAgrupadas sem interferir no state do vuex */
        let ferramentasAgrupadas = JSON.parse(JSON.stringify(this.$store.state.app.modulosPerfisLiberados.ferramentas));

        for (const categoria in ferramentasAgrupadas) {
          ferramentasAgrupadas[categoria] = ferramentasAgrupadas[categoria].filter((ferramenta) => {
            if (ferramenta.tipo !== 'DADOS') return false;

            let ferramentaLiberada = false;
            if (ferramenta.status) {
              ferramentaLiberada = this.ferramentasLiberadas.some((ferramentaLiberada) => ferramentaLiberada.id == ferramenta.id);
            }

            ferramenta.status = ferramentaLiberada;
            return true;
          });
        }
        return ferramentasAgrupadas;
      }
    },
    methods: {
      exibirFerramenta(adminCondition) {
        return !adminCondition || (this.userIsAdmin && adminCondition);
      },
      categoriaIsPrivada(categoriaNome) {
        let categoria = this.categorias.find((categoria) => categoria.nome == categoriaNome);

        return categoria.categoria_privada ? true : false;
      },
      setLink(link, status) {
        if (status) {
          return `https://${this.$store.getters.getEmpresa}.gestaohexa.com.br/${link}`;
        } else {
          return '';
        }
      }
    }
  };
</script>

<style>
  .disabled-card {
    opacity: 0.5;
    border-color: transparent !important;
  }
</style>